var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"quote"},[_c('div',{staticClass:"copy",domProps:{"innerHTML":_vm._s(_vm.copy)}}),_c('span',{staticClass:"author",domProps:{"innerHTML":_vm._s(_vm.author)}})])}
var staticRenderFns = []

export { render, staticRenderFns }